import {Injectable} from '@angular/core';

import 'rxjs/add/operator/map'

import {ApiService} from './api.service';
import {Http, Headers, RequestOptions, Response, ResponseContentType} from '@angular/http';
import * as myGlobals from '../globals';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class ResponseService {

    constructor(
        private http: Http,
        private apiService: ApiService,
        private authenticationService: AuthenticationService) {
    }

    getResponses(data) {
        return this.apiService.http_post('/responses/list', data);
    }
    getResponseDetails(user_id, response_count) {
        return this.apiService.http_get('/responses/details/' + user_id + '/' + response_count);
    }
    deleteResponse(resp) {
        return this.apiService.http_post('/responses/deleteResponse', resp);
    }
    exportResponse(user_id, response_count) {
        return this.apiService.http_get('/responses/exportResponse/' + user_id + '/' + response_count);
    }
    
    exportPdf(user_id, response_count) {
        //return this.apiService.http_get('/responses/exportPdf');
        let headers = new Headers({'Authorization': 'Bearer ' + this.authenticationService.token});
        let options = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
        
        return this.http.get(myGlobals.apiUrl+'/responses/exportPdf/' + user_id + '/' + response_count, options).map(
        (res) => {
            return new Blob([res.blob()], { type: 'application/pdf' })
        });
    }
    
    sendResponse(data) {
        return this.apiService.http_post('/responses/sendResponse', data);
    }
    
    detailedReport() {
        
        //return this.apiService.http_get('/responses/detailedReport');
//        let headers = new Headers({'Authorization': 'Bearer ' + this.authenticationService.token});
//        headers.append('Content-Type', 'application/vnd.ms-excel');
//        let options = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
//        
//        return this.http.get(myGlobals.apiUrl+'/responses/detailedReport', options)
//        .map(
//        (res) => {
//            console.log(res)
//            return new Blob([res.blob()], { type: 'application/vnd.ms-excel' })
//        });
        //.catch(error=>{return Observable.throw(error)})
        
        const type = 'application/vnd.ms-excel';
        const options = new RequestOptions({
                    responseType: ResponseContentType.Blob,
                    headers: new Headers({ 'Accept': type,'Authorization': 'Bearer ' + this.authenticationService.token })
              });

        return this.http.get(myGlobals.apiUrl+'/responses/detailedReport', options)
                 //.catch(errorResponse => Observable.throw(errorResponse.json()))
                 .map((response) => { 
                       if (response instanceof Response) {
                          return response.blob();
                       }
                       return response;
                  })
                 //.subscribe(data => saveAs(data, filename),
                           // error => console.log(error)); // implement your error handling here
    }
    
    summaryReport() {
        
        //return this.apiService.http_get('/responses/summaryReport');
        const type = 'application/vnd.ms-excel';
        const options = new RequestOptions({
                    responseType: ResponseContentType.Blob,
                    headers: new Headers({ 'Accept': type,'Authorization': 'Bearer ' + this.authenticationService.token })
              });

        return this.http.get(myGlobals.apiUrl+'/responses/summaryReport', options)
                 .map((response) => { 
                       if (response instanceof Response) {
                          return response.blob();
                       }
                       return response;
                  })
    }
}


// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/response.service.ts